<template>
  <div class="softTop flex_row">
    <div class="normal flex_column" :class="idx==index?'xz':''" v-for="(item,index) in list" @click="go(index)">
      <div class="info" v-for="info in item.info">{{info}}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "softTop",
  data() {
    return {
      list: [],
      proList: [],
      idx: -1
    }
  },
  created() {
    let list = [
      {
        proId: 0,
        info: ['眼科/视光', 'HIS系统']
      },
      {
        proId: 1,
        info: ['智能营销', 'SCRM']
      },
      {
        proId: 2,
        info: ['电子病历', 'EHR']
      },
      {
        proId: 3,
        info: ['AI辅助诊断', '人工智能处方']
      },
      {
        proId: 4,
        info: ['ERP', '系统']
      },
      {
        proId: 5,
        info: ['远程手术', '诊疗系统']
      },
      {
        proId: 6,
        info: ['无人值守', 'AI验配系统']
      },
      {
        proId: 7,
        info: ['校医联盟', '近视防控系统']
      },
      {
        proId: 8,
        info: ['运营大数据', '智能报告系统']
      },
      {
        proId: 9,
        info: ['24小时呵护', '云诊视系统']
      },
    ];
    this.list = list;
    let proList = ['/OphthalmicSystem','/SCRM','/EHR','/AIDiagnosis','/ERP','/HNIS','/FittSystem','/ControlSystem','/ReportSystem','/CareSystem'];
    this.proList = proList;
    this.go(this.$store.state.ProId);
  },
  methods: {
    go(index){
      if(this.idx !== index) {
        this.idx = index;
        this.$store.commit('setProId', index);
        this.$router.push({path: this.proList[index]});
      }
    }
  }
}
</script>

<style scoped lang="scss">
.softTop {
  width: 100vw;
  min-width: 1024px;
  background: #fff;
  padding: 0.3rem 0 0.18rem;

  .normal {
    margin: 0 0.3rem;
    cursor: pointer;
    .info {
      font-size: 0.16rem;
      color: #767676;
    }
  }
  .xz {
    .info {
      color: #00A0E9;
    }
  }
}
</style>
